import { de_DE_formal } from "@App/locales/de_DE-formal";
import { de_DE_globalTranslations } from "@App/locales/de_DE-globalTranslations";

export const meinauto = {
  ...de_DE_formal,
  ...{
    translation: {
      ...de_DE_globalTranslations.translation,
      layout: {
        backText: "Zurück zu meinauto.de",
      },
      linkToHome: "https://werkstatt.repareo.de/partner/meinauto",
      tireStepText: {
        tiresAlreadyStored: "meineReifen",
      },
      booking: {
        headline: "Termin buchen",
        subheadline: "Service: {{service}}",
        "slot-taken-1": "Schade! Da war leider jemand schneller und hat Ihren Wunschtermin am",
        "slot-taken-2": "reserviert. Bitte wählen Sie einen anderen Termin.",
        "no-slots": "Leider sind für diese Werkstatt aktuell keine freien Termine verfügbar.",
        "no-slots-contact-phone": `Bitte kontaktieren Sie die Werkstatt direkt unter <tel>{{tel}}</tel>.`,
        "error-nearest-slot-gone":
          "Puh, die Werkstatt hat einiges zu tun: Der {{ day }} ist jetzt schon ausgebucht. Ab dem {{ newDay }} sind wieder Termine frei.",
        "next-free-slot": "Nächster freier Termin:",
        "chosen-slot": "Ausgewählter Termin:",
        "please-choose-services": "Bitte wählen Sie die gewünschten Services",
        "more-information-link": "Mehr zum Terminablauf",
        hint: " Die finale Terminbestätigung erfolgt durch die Prüfstelle.",
        blocking: "Termin wird reserviert...",
        submit: "Termin sichern",
        moreInformation: {
          headline: "Wie genau läuft der Termin ab?",
          "bullet-point-1": "Ihre Buchung geht direkt in den Kalender der {{garageType}}.",
          "bullet-point-2": "Bitte geben Sie Ihr Auto zu Beginn des Termins ab.",
          "bullet-point-3":
            "Die {{garageType}} informiert Sie telefonisch, sobald Sie Ihr Auto abholen können.",
          "bullet-point-4": "Sie können ihren Termin jederzeit kostenfrei absagen.",
          "bullet-point-5": "",
          "bullet-point-6": "",
          "instant-booking":
            "Diese Werkstatt erhält Ihren gebuchten Termin direkt in den Kalender. Somit ist der Termin sofort bestätigt.",
          "request-booking":
            "Diese Werkstatt erhält eine Terminanfrage und bestätigt Ihren Wunschtermin so schnell wie möglich.",
        },
        vehicleReturn: {
          headline: "Termine",
          submit: "Termin auswählen",
          tos: {
            headline: "Hinweise zur vorzeitigen Fahrzeugrückgabe",
            subheadline:
              "Der gewählte Termin zur Fahrzeugrückgabe liegt vor dem vereinbarten Vertragsende. Eine Rückgabe zu diesem Zeitpunkt stellt eine vorzeitige einvernehmliche Vertragsbeendigung dar.",
            text: "Mit der Vereinbarung der vorzeitigen Beendigung des Leasingvertrages entstehen für Sie Kosten, die sich zusammensetzen aus der Summe der noch bis zum regulären Vertragsende geschuldeten jeweils abgezinsten offenen Netto-Leasingraten nebst kalkuliertem Restwert (sowie der vereinbarten Netto-Rückgabeoptionsgebühr im Fall eines Vario-Finanzierungsvertrages) abzüglich des Netto-Händlereinkaufswertes zum Zeitpunkt der Rückgabe des Fahrzeuges. Eine Vergütung für Mehr- oder Minderkilometer entfällt dabei, während ein etwaiger Minderwertausgleich aufgrund des Erhaltungszustandes des Fahrzeuges und übrige vertragliche Kosten im Zuge der Rückgabe hiervon unberührt bleiben.",
          },
          "free-return": {
            text: "Um Kosten für den Rücktransport deines Leasing-Fahrzeugs gemäß Allgemeiner Geschäftsbedingungen 18.2 zu sparen, kannst du es an einer Partner-Rückgabestation im Großraum München abgeben. Dort entfallen die Kosten für den Rücktransport.",
            "view-free": "Partner-Rückgabestationen ohne Aufpreis anzeigen",
            "view-all": "Alle Rückgabestationen anzeigen",
          },
        },
        "daypicker-legend-yellow-94": "Vorzeitige Fahrzeugrückgabe verursacht Zusatzkosten",
      },
      contractDetails: {
        error: {
          general: `Etwas ist schiefgegangen. Bitte schreiben Sie eine E-Mail an <a>werkstattmeister@repareo.de</a>`,
          not_found: `Wir konnten anhand Ihrer Vertragsdaten keinen Vertrag finden. Bitte überprüfen Sie Ihre Vertragsdaten oder schreiben Sie eine E-Mail an <a>MeinAuto-Rueckgabe@mobility-concept.de</a>.`,
          not_found_email: "MeinAuto-Rueckgabe@mobility-concept.de",
          does_not_match: `Die eingegebenen Daten passen nicht zum gefundenen Vertrag. Bitte überprüfen Sie Vertragsnummer und Kennzeichen oder schreiben Sie eine E-Mail an <a>MeinAuto-Rueckgabe@mobility-concept.de</a>.`,
        },
      },
      contractNumberHelp: {
        heading: "Wo finde ich meine Vertragsnummer?",
        ariaLabel: "Wo finden Sie Ihre Vertragsnummer?",
        closeFullscreen: "Bild schließen",
        previous: "Vorheriges Bild",
        next: "Nächstes Bild",
        captions: {
          offer: "Ihre Angebots-E-Mail",
          confirmation: "Ihre Bestellbestätigung",
          overview: "Übersicht in Ihrem MeinAuto-Konto",
          detail: "Detailansicht Ihrer Bestellung",
        },
      },
    },
  },
};
